import { keyBy } from "lodash";
import { ImportResultsAction, ImportResultsActions } from "../actions";
import { ImportResultsState } from "../state";

export const importResultsInitialState: ImportResultsState = {
  isLoading: true,
};

export const importResultsReducer = (state: ImportResultsState, action: ImportResultsActions): ImportResultsState => {
  switch (action.type) {
    case ImportResultsAction.LoadResults:
      return Object.freeze({
        ...state,
        isLoading: true,
      });
    case ImportResultsAction.LoadResultsSuccess:
      const results = keyBy(action.result, "stepType");
      return Object.freeze({
        ...state,
        ...action.result,
        isLoading: false,
        results,
      });
    case ImportResultsAction.LoadResultsFailure:
      return Object.freeze({
        ...state,
        isLoading: false,
      });
    default:
      throw new Error(`Action ${JSON.stringify(action)} not handled in importResultsReducer`);
  }
};
